import { Grid, Typography, useTheme } from "@mui/material";
import { useContext, useState } from "react";
import { AppContext } from "../../../Utilities/AppContext";

type Props = {
    copyName: string;
};

export const Header = ({ copyName }: Props) => {
    const { store, setStore } = useContext(AppContext);
    const [logoSrc, setLogoSrc] = useState("");
    const [secondaryLogos, setSecondaryLogos] = useState<string[]>([]);
    const theme = useTheme();

    const getDataInRange = (index: number, limit: number, data: any[]) => {
        const output: any[] = [];

        for (index; index < limit; index++) {
            if (data[index]) {
                output.push(data[index]);
            }
        }

        return output;
    };

    return (
        <Grid item container xs={12} alignItems="center">
            <Grid item xs={2}>
                <img
                    src={store.logoURL}
                    alt="logo"
                    width="60px"
                    height="60px"
                />
            </Grid>

            <Grid
                item
                xs={8}
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    textAlign: "center",
                }}
            >
                <Typography variant="h6">
                    Sarhad Rural Support Programme
                </Typography>
                <Typography>
                    Electricity Bill <span>{`(${copyName})`}</span>
                </Typography>
                {/* <Typography variant="caption">{`(${copyName})`}</Typography> */}
            </Grid>

            <Grid
                item
                xs={2}
                display="flex"
                justifyContent="flex-end"
                gap={theme.spacing(3)}
            >
                {secondaryLogos.map((l, id) => (
                    <img
                        key={id}
                        src={l}
                        alt="logo"
                        width="60px"
                        height="60px"
                    />
                ))}
            </Grid>
        </Grid>
    );
};
